import axios from 'axios'

export default {
    async sendEmailToCustomer(order_id, email) {
        return await axios.get(
            `report/${order_id}/customer_statement?email=${email}`
        )
    },
    async getStatement(order_id) {
        return await axios.get(
            `report/${order_id}/customer_statement?type=display`
        )
    },
    async fetch(params) {
        return await axios.get(`report/headers`, { params })
    },
    async fetchReport(params) {
        return await axios.get(`report`, { params })
    },

    async fetchDrivers() {
        return await axios.get(`user`)
    },
   
  
}
